import React, { useContext, useEffect, useRef, useState } from 'react'
import { Col } from 'react-bootstrap'
import objectPath from 'object-path'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { themeDefault } from '../../themes/containerTheme'
import { DesignContext } from 'contexts/DesignContext'
import FormLoading from 'components/Loader/FormLoading'
import {
  checkHasShow,
  checkIsShow,
} from 'designer/component/action/condition/Action'
import { getShowUiConfig } from 'designer/component/action/Config'
import useAuth from 'hooks/useAuth'
import { isEmpty } from 'designer/component/action/condition/State'
import { useShowHideTransition } from './ShowHideTransition'

const ComponentWrapper = (props) => {
  let {
    uischema,
    children,
    theme = themeDefault,
    isLoad = false,
    height,
  } = props

  const designContext = useContext(DesignContext)
  const {
    jsonForm,
    isUiChanged,
    setIsUiChanged,
    elementAction,
    isPage,
  } = designContext
  const { config } = useAuth()
  const isShowUiConfig = getShowUiConfig({ uischema, config, jsonForm })
  const isLoadingUi = objectPath.get(elementAction, ['isLoading', uischema.key])
  let hasShow = checkHasShow({ designContext, uischema, config: props.config })
  let isShow = checkIsShow({ designContext, uischema, config: props.config })
  let minWidth = uischema?.minWidth ? {} : { minWidth: uischema?.minWidth }
  let maxWidth = uischema?.maxWidth ? {} : { maxWidth: uischema?.maxWidth }
  let isDisplayShow = hasShow ? isShow : isShowUiConfig
  let transitionKey =
    objectPath.get(elementAction, ['showHideTransition', uischema.key]) ||
    objectPath.get(elementAction, ['showHideTransition', uischema.name])
  const showHideTransition = useShowHideTransition(
    isDisplayShow,
    undefined,
    hasShow,
    transitionKey,
  )
  const shouldRenderChildren =
    isDisplayShow || !showHideTransition.hidden || isLoadingUi

  const [isShowLoad, setIsShowLoad] = useState(false)
  const [isShowUi, setIsShowUi] = useState(false)
  const isMountedRef = useRef(true)
  const isShowComponentLoad = isPage !== 1 && isShowLoad

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  useEffect(() => {
    if (!isLoadingUi) {
      const timeout = setTimeout(() => {
        if (isMountedRef.current) {
          setIsShowLoad(false)
        }
      }, 0)
      return () => clearTimeout(timeout)
    } else {
      setIsShowLoad(true)
    }
  }, [isLoadingUi])

  let hasStartCallAPI = objectPath.has(isUiChanged, [
    'isStartCallAPI',
    uischema.key,
  ])
  let isStartCallAPI = objectPath.get(isUiChanged, [
    'isStartCallAPI',
    uischema.key,
  ])
  let callAPI = objectPath.get(isUiChanged, ['callAPI'])

  const clearLoadCall = () => {
    objectPath.del(isUiChanged, ['isStartCallAPI'])
    objectPath.del(isUiChanged, ['callAPI'])
    setIsUiChanged(isUiChanged)
    setIsShowLoad(false)
  }

  useEffect(() => {
    if (!hasStartCallAPI) return
    if (isStartCallAPI) {
      if (!isShowLoad) {
        setIsShowLoad(true)
      }

      if (isEmpty(callAPI)) {
        clearLoadCall()
      }
    }
  }, [JSON.stringify(callAPI)])

  useEffect(() => {
    setIsShowUi(!isShowLoad)
  }, [isShowLoad])

  return (
    <Col
      ref={showHideTransition.ref}
      sm={uischema.layoutWidth}
      data-designer-name={uischema.name}
      style={{
        padding: uischema.layoutPadding ? '0' : '0 .5rem',
        zIndex: uischema?.zIndex ?? 0,
        ...minWidth,
        ...maxWidth,
        ...showHideTransition.style,
      }}
      hidden={showHideTransition.hidden}
    >
      {isPage !== 1 && (
        <div
          style={{
            display: !isShowComponentLoad ? 'none' : 'block',
          }}
        >
          <FormLoading height={height} />
        </div>
      )}
      <div
        style={{
          display: isShowComponentLoad ? 'none' : 'block',
          opacity: isPage === 1 || isShowUi ? 100 : 0,
          transition: 'opacity .5s ease-in-out',
        }}
      >
        {shouldRenderChildren && (
          <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
        )}
      </div>
    </Col>
  )
}

export default ComponentWrapper
